import supabase from '../supabase/supabase';
const TABLE='affiliates_persistent';
const PAYOUT_TABLE='affiliate_payouts';
const COMMISSION_RATE=0.20;

export function generateCode(email) {
  const base=email.split('@')[0].replace(/[^a-z0-9]/gi,'').toLowerCase().slice(0,8);
  const rand=Math.random().toString(36).slice(2,6).toUpperCase();
  return `${base}-${rand}`;
}

export async function getOrCreateAffiliate(user) {
  if (!user) return null;
  try {
    const {data:existing}=await supabase.from(TABLE).select('*').eq('email',user.email).single();
    if (existing) return existing;
    const code=generateCode(user.email);
    const {data:created,error}=await supabase.from(TABLE).insert({email:user.email,code,name:user.user_metadata?.name||user.email.split('@')[0]}).select().single();
    if (error) throw error;
    return created;
  } catch(err) {
    console.error('getOrCreateAffiliate failed:',err);
    return null;
  }
}

export async function recordReferralClick(code) {
  if (!code) return;
  try {
    const {data}=await supabase.from(TABLE).select('id,clicks').eq('code',code).single();
    if (data) await supabase.from(TABLE).update({clicks:(data.clicks||0)+1}).eq('id',data.id);
  } catch {}
}

export async function recordCommission(referralCode,saleAmountUsd) {
  if (!referralCode) return;
  try {
    const {data}=await supabase.from(TABLE).select('*').eq('code',referralCode).single();
    if (!data) return;
    const commission=+(saleAmountUsd*COMMISSION_RATE).toFixed(2);
    await supabase.from(TABLE).update({
      total_sales:(data.total_sales||0)+saleAmountUsd,
      total_earned:(data.total_earned||0)+commission,
      conversions:(data.conversions||0)+1,
    }).eq('id',data.id);
  } catch(err) {
    console.error('recordCommission failed:',err);
  }
}

export async function requestPayout({affiliateId,code,email,method,address,amount,notes}) {
  const {error}=await supabase.from(PAYOUT_TABLE).insert({
    affiliate_id: affiliateId,
    affiliate_code: code,
    affiliate_email: email,
    method,
    address,
    amount,
    notes: notes||'',
    status: 'pending',
  });
  if (error) throw new Error(error.message);
}

export async function loadPayoutRequests() {
  const {data,error}=await supabase.from(PAYOUT_TABLE).select('*').order('created_at',{ascending:false});
  if (error) throw new Error(error.message);
  return data||[];
}

export async function updatePayoutStatus(id,status) {
  const {error}=await supabase.from(PAYOUT_TABLE).update({status}).eq('id',id);
  if (error) throw new Error(error.message);
}

export function getReferralCodeFromUrl() {
  const params=new URLSearchParams(window.location.search);
  return params.get('ref')||null;
}

export function storeReferralCode(code) {
  if (code) sessionStorage.setItem('ref_code',code);
}

export function getStoredReferralCode() {
  return sessionStorage.getItem('ref_code')||null;
}

export const COMMISSION_RATE_PCT=20;